<svg viewBox="0 0 12 15" [style.height]="this._height" [style.width]="this._width" xmlns="http://www.w3.org/2000/svg">
    <g>
        <rect fill="none" id="canvas_background" [style.height]="this._height" [style.width]="this._width" y="-1" x="-1"/>
    </g>
    <g>
        <path [style.stroke]="this._strokeColor" [style.fill]="this._fillColor" d="m5.62222,0.61855a4.76553,4.888 0 0 0 -4.864,4.788c0,3.591 4.864,8.892 4.864,8.892s4.864,-5.3 4.864,-8.892a4.76553,4.888 0 0 0 -4.864,-4.788zm0,6.5a1.7042,1.748 0 0 1 -1.73735,-1.71a1.73833,1.783 0 0 1 3.4747,0a1.7042,1.748 0 0 1 -1.73735,1.71z" id="ic_place_24px-2"/>
    </g>
</svg>
